import { render, staticRenderFns } from "./SelectPracticeModal.vue?vue&type=template&id=653fbeb4"
import script from "./SelectPracticeModal.vue?vue&type=script&lang=js"
export * from "./SelectPracticeModal.vue?vue&type=script&lang=js"
import style0 from "./SelectPracticeModal.vue?vue&type=style&index=0&id=653fbeb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports